import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/apiClient";
import { Eye, Lock } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const u = await login(email.trim(), password.trim());
      nav(u.role === "admin" ? "/admin" : "/network");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <main className="bg-onyx min-h-screen pt-16 flex items-center grain" data-testid="login-page">
      <div className="max-w-md mx-auto w-full px-5 py-20">
        <div className="text-center mb-10">
          <Eye className="text-gold mx-auto mb-4" size={40} strokeWidth={1.5} />
          <h1 className="font-serif text-4xl text-bone">Credentialed Access</h1>
          <p className="text-bone/50 mt-2">Sign in to import content and manage the archive.</p>
        </div>
        <form onSubmit={submit} className="bg-surface border border-white/10 p-8 space-y-5" data-testid="login-form">
          <div>
            <label className="text-xs uppercase tracking-widest text-bone/60 mb-2 block">Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email"
              autoCapitalize="none" autoCorrect="off" spellCheck={false} autoComplete="username"
              className="w-full bg-black/50 border border-white/10 px-4 py-3 text-bone focus:outline-none focus:border-gold/50" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-bone/60 mb-2 block">Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password"
              autoCapitalize="none" autoCorrect="off" spellCheck={false} autoComplete="current-password"
              className="w-full bg-black/50 border border-white/10 px-4 py-3 text-bone focus:outline-none focus:border-gold/50" />
          </div>
          {error && <p className="text-red-400 text-sm" data-testid="login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="login-submit"
            className="w-full bg-gold text-black py-3 font-medium hover:bg-gold2 transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
            <Lock size={16} /> {loading ? "Signing in..." : "Sign In"}
          </button>
          <div className="text-center pt-1">
            <Link to="/forgot-password" className="text-bone/50 hover:text-gold text-sm transition-colors" data-testid="forgot-password-link">
              Forgot your password?
            </Link>
          </div>
        </form>
      </div>
    </main>
  );
}
